// src/pages/About.js
export default function About() {
  return <h2>About This App</h2>;
}
